import { render } from "./PartsAboutSemiOrderBrand.vue?vue&type=template&id=2874db4c&scoped=true"
import script from "./PartsAboutSemiOrderBrand.vue?vue&type=script&lang=js"
export * from "./PartsAboutSemiOrderBrand.vue?vue&type=script&lang=js"

import "./PartsAboutSemiOrderBrand.vue?vue&type=style&index=0&id=2874db4c&scoped=true&lang=css"

import exportComponent from "/Users/maru/Desktop/東野材木/hojokin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2874db4c"]])

export default __exports__